export default __webpack_public_path__ + "static/media/socialimpact.4790be27.jpeg";